<template>
  <div class="report-container">
    <el-alert center type="warning">
      Currently viewing <b>Prior Year Reports</b>. Switch to <router-link class="router-link"
        :to="{ name: 'reportDashboard' }">Current Year
        Report</router-link>
    </el-alert>
    <el-row :gutter="18">
      <el-col :span="24" class="mb-3">
        <div class="chart-holder">
          <daily-traffic-chart prior-year :date-range="dateRange" :for-office="selectedOffice"></daily-traffic-chart>
        </div>
      </el-col>
      <el-col :span="24" class="mb-3">
        <office-summary-table prior-year :date-range="dateRange" :for-office="selectedOffice"></office-summary-table>
      </el-col>
      <el-col :span="12" class="mb-3">
        <div class="donut-holder">
          <eb-distribution-chart prior-year :date-range="dateRange"
            :for-office="selectedOffice"></eb-distribution-chart>
        </div>
      </el-col>
      <el-col :span="12" class="mb-3">
        <div class="donut-holder">
          <eb-did-not-qualify-chart prior-year :date-range="dateRange"
            :for-office="selectedOffice"></eb-did-not-qualify-chart>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import DailyTrafficChart from '@/components/charts/DailyTraffic';
import OfficeSummaryTable from '@/components/tables/OfficeSummary.vue';
import EbDistributionChart from '@/components/charts/EBDistribution';
import EbDidNotQualifyChart from '@/components/charts/EBDidNotQualifyDistribution';
import ReportBaseMixin from '@/views/reports/ReportBaseMixin';

export default {
  components: {
    DailyTrafficChart,
    OfficeSummaryTable,
    EbDistributionChart,
    EbDidNotQualifyChart,
  },
  mixins: [
    ReportBaseMixin,
  ],
};

</script>
